import { useState, FormEvent } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    childAge: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('phone', formData.phone);
      formBody.append('childAge', formData.childAge);
      formBody.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d5e9101uv4ce4ehsekpg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', phone: '', childAge: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-24 bg-gradient-to-b from-white to-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#3E2723] mb-4">
            Comienza el Viaje Musical
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Contáctanos hoy y da el primer paso hacia el crecimiento de tu hijo
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 max-w-6xl mx-auto">
          <div>
            <div className="bg-white rounded-3xl shadow-xl p-8 mb-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Información de Contacto</h3>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#FFF8E1] rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-2xl text-[#D2691E]"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Ubicación</h4>
                    <p className="text-gray-600">Plymouth & Fortaleza Church</p>
                    <p className="text-gray-600">5838 Magnolia Ave.</p>
                    <p className="text-gray-600">Whittier, CA 90601</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#FFF8E1] rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-2xl text-[#D2691E]"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Teléfonos</h4>
                    <p className="text-gray-600"><span className="font-semibold">Emily:</span> (956) 635-5295</p>
                    <p className="text-gray-600"><span className="font-semibold">Lily:</span> (562) 842-6548</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#FFF8E1] rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-2xl text-[#D2691E]"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Email</h4>
                    <p className="text-gray-600">info@fortalezamusic.com</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#FFF8E1] rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-2xl text-[#D2691E]"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Horario de Clases</h4>
                    <p className="text-gray-600">Martes y Jueves</p>
                    <p className="text-gray-600">5:00 PM en adelante</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-[#D2691E] to-[#B8571A] rounded-3xl shadow-xl p-8 text-white">
              <h3 className="text-2xl font-bold mb-4">¿Por Qué Elegir Fortaleza?</h3>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl flex-shrink-0"></i>
                  <span>Más de 130 años de confianza comunitaria</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl flex-shrink-0"></i>
                  <span>Instructora con experiencia internacional</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl flex-shrink-0"></i>
                  <span>Ambiente seguro y acogedor</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl flex-shrink-0"></i>
                  <span>Grupos pequeños para atención personalizada</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl flex-shrink-0"></i>
                  <span>Conexión con herencia cultural</span>
                </li>
              </ul>
            </div>
          </div>

          <div>
            <form onSubmit={handleSubmit} className="bg-white rounded-3xl shadow-xl p-8" data-readdy-form id="contact-form">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Solicita Información</h3>
              
              <div className="space-y-5">
                <div>
                  <label htmlFor="name" className="block text-sm font-semibold text-gray-700 mb-2">
                    Nombre del Padre/Madre *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#D2691E] focus:outline-none transition-colors text-sm"
                    placeholder="Tu nombre completo"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#D2691E] focus:outline-none transition-colors text-sm"
                    placeholder="tu@email.com"
                  />
                </div>

                <div>
                  <label htmlFor="phone" className="block text-sm font-semibold text-gray-700 mb-2">
                    Teléfono *
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    required
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#D2691E] focus:outline-none transition-colors text-sm"
                    placeholder="(562) 555-0123"
                  />
                </div>

                <div>
                  <label htmlFor="childAge" className="block text-sm font-semibold text-gray-700 mb-2">
                    Edad del Niño/a *
                  </label>
                  <select
                    id="childAge"
                    name="childAge"
                    required
                    value={formData.childAge}
                    onChange={(e) => setFormData({ ...formData, childAge: e.target.value })}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#D2691E] focus:outline-none transition-colors text-sm cursor-pointer"
                  >
                    <option value="">Selecciona una edad</option>
                    <option value="5">5 años</option>
                    <option value="6">6 años</option>
                    <option value="7">7 años</option>
                    <option value="8">8 años</option>
                    <option value="9">9 años</option>
                    <option value="10">10 años</option>
                    <option value="11">11 años</option>
                    <option value="12">12 años</option>
                    <option value="13">13 años</option>
                    <option value="14">14 años</option>
                    <option value="15">15 años</option>
                    <option value="16">16 años</option>
                    <option value="17">17 años</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-semibold text-gray-700 mb-2">
                    Mensaje (Opcional)
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows={4}
                    maxLength={500}
                    value={formData.message}
                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#D2691E] focus:outline-none transition-colors resize-none text-sm"
                    placeholder="¿Tiene tu hijo experiencia previa? ¿Alguna pregunta específica?"
                  />
                  <p className="text-xs text-gray-500 mt-1">{formData.message.length}/500 caracteres</p>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-[#D2691E] text-white py-4 rounded-full hover:bg-[#B8571A] transition-all shadow-lg font-semibold text-lg disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                >
                  {isSubmitting ? 'Enviando...' : 'Enviar Solicitud'}
                </button>

                {submitStatus === 'success' && (
                  <div className="bg-green-50 border-2 border-green-200 rounded-xl p-4 text-center">
                    <i className="ri-check-line text-2xl text-green-600 mb-2"></i>
                    <p className="text-green-800 font-semibold">¡Mensaje enviado con éxito!</p>
                    <p className="text-green-700 text-sm mt-1">Nos pondremos en contacto pronto.</p>
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="bg-red-50 border-2 border-red-200 rounded-xl p-4 text-center">
                    <i className="ri-error-warning-line text-2xl text-red-600 mb-2"></i>
                    <p className="text-red-800 font-semibold">Error al enviar</p>
                    <p className="text-red-700 text-sm mt-1">Por favor, intenta de nuevo.</p>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
